export const initAmplitude = () => true;

export const setAmplitudeUserDevice = (installationToken) => true;

export const setAmplitudeUserId = (userId) => true;

export const setAmplitudeUserProperties = (properties) => true;

export const sendAmplitudeData = (eventType, eventProperties) => true;
